import { useSyncExternalStore } from 'react';

/**
 * 담은 원단 버튼을 앉힐 자리 (12회차 m58).
 *
 * 사진 검색은 화면의 주 행동(「유사 원단 찾기」)이 화면 아래쪽에 있어, 떠 있는 「담은 원단」 버튼이 그 버튼을 덮었다
 * (768 첫 화면 161×40, 1280×640 에서도). 휴대폰은 실행 막대 왼쪽 칸으로 접어 두었는데(8회차 M23) 태블릿 · PC 는 떠 있었다.
 * 이제 사진 검색 화면은 실행 줄 왼쪽에 자리(`.tray-dock`)를 두고 알린다 — 트레이는 그 자리가 있으면 버튼을 그 안에 그린다(포털).
 * 폭과 상관없이 같은 규칙이라 어느 폭 · 높이에서도 주 버튼과 겹칠 수 없다. 자리는 담은 원단이 있을 때만 보인다(CSS).
 */
let dock: HTMLElement | null = null;
const subs = new Set<() => void>();

/** 사진 검색 화면이 ref 로 넘긴다 — 떠날 때 null */
export function setTrayDock(el: HTMLElement | null): void {
  if (dock === el) return;
  dock = el;
  subs.forEach((f) => f());
}

export function useTrayDock(): HTMLElement | null {
  return useSyncExternalStore(
    (cb) => { subs.add(cb); return () => { subs.delete(cb); }; },
    () => dock,
    () => null,
  );
}
